import React, {useState} from "react";
import {Card, Col, Container, InputGroup, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import * as formik from 'formik';
import * as yup from 'yup';
import Button from "react-bootstrap/Button";
import provList from "../../_helpers/provList.js";
import rootStore from "../../stores/rootStore.js";
import {signUpApi} from "../../api/signup.js";
import bctcLogo from "../../images/BCTC_Logo_Horiz_small.png";
function RegisterResellerPage() {
    const { Formik } = formik;

    const [pageState,setPageState] = useState({
       formSubmitted: false
    });
    const schema = yup.object().shape({
        firstName: yup.string().required('First Name is required'),
        lastName: yup.string().required('Last Name is required'),
        organizationName: yup.string().required('Company name is required'),
        email: yup.string().email('Invalid email format').required('Email is required'),
        password: yup.string()
            .required('Password is required')
            .matches(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/,
                "Password must be at least 8 characters, with an uppercase letter, lowercase letter, and a number."
            ),
        passwordConfirm: yup.string()
            .required('Password confirm is required')
            .oneOf([yup.ref('password')], 'Passwords must match'),
        address: yup.string().required('Address is required'),
        city: yup.string().required('City is required'),
        prov: yup.string().required('Province is required'),
        postCode: yup.string().required('Postal Code is required'),
        country: yup.string().required('Country is required'),
        phoneNumber: yup.string().required('Phone number is required'),
        terms: yup.bool().required().oneOf([true], 'Terms must be accepted'),
    });

    if (pageState.formSubmitted){
        return (
            <>
                <h1>Reseller Registration Submitted</h1>
                <p>You will recieve an email that will confirm your email address with us. Click on the link in the email
                and you will be returned to the bctaxcerts.com site where you will be able to complete the reseller
                onboarding process.</p>
            </>

        )
    } else {
        return (
            <div>
                <Container>
                    <Row className="vh-100 d-flex justify-content-center align-items-center">
                        <Col md={12} lg={12} xs={12}>
                            <div className="border border-3 border-primary"></div>
                            <Card className="shadow">
                                <Card.Body>
                                    <div className="text-center align-items-start mb-4">
                                        <img
                                            src={bctcLogo}
                                            height="100"
                                            className="d-inline-block align-top"
                                            alt="React Bootstrap logo"
                                        />
                                    </div>
                                    <Formik
                                        validationSchema={schema}
                                        onSubmit={async (values, { setSubmitting }) => {
                                            try {
                                                setSubmitting(true);
                                                signUpApi.resellerSignup(values.firstName, values.lastName, values.email, values.password, values.phoneNumber,
                                                    values.organizationName, values.address, values.city, values.prov, values.postCode, values.country);
                                            } finally {
                                                setSubmitting(false);
                                                setPageState(prevState => {
                                                    return {...prevState, formSubmitted : true}
                                                });
                                            }

                                        }}
                                        initialValues={{
                                            firstName: '',
                                            lastName: '',
                                            organizationName: '',
                                            username: '',
                                            address: '',
                                            phoneNumber: '',
                                            city: '',
                                            prov: 'BC',
                                            postCode: '',
                                            country: 'CA',
                                            terms: false,
                                        }}
                                    >
                                        {({ handleSubmit, handleChange, touched, values, isSubmitting, errors }) => (
                                            <Form noValidate onSubmit={handleSubmit}>
                                                <h1>Reseller Sign-Up</h1>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} md="4" controlId="firstName">
                                                        <Form.Label>First name</Form.Label>
                                                        <InputGroup hasValidation>
                                                            <Form.Control
                                                                type="text"
                                                                name="firstName"
                                                                value={values.firstName}
                                                                onChange={handleChange}
                                                                isInvalid={touched.firstName && !!errors.firstName}
                                                            />
                                                            {touched.firstName && (<Form.Control.Feedback type="invalid">
                                                                {errors.firstName}
                                                            </Form.Control.Feedback>)}
                                                        </InputGroup>
                                                    </Form.Group>
                                                    <Form.Group as={Col} md="4" controlId="lastName">
                                                        <Form.Label>Last name</Form.Label>
                                                        <InputGroup hasValidation>
                                                            <Form.Control
                                                                type="text"
                                                                name="lastName"
                                                                value={values.lastName}
                                                                onChange={handleChange}
                                                                isInvalid={touched.lastName && !!errors.lastName}
                                                            />
                                                            {touched.lastName && (<Form.Control.Feedback type="invalid">
                                                                {errors.lastName}
                                                            </Form.Control.Feedback>)}
                                                        </InputGroup>
                                                    </Form.Group>
                                                    <Form.Group as={Col} md="4" controlId="organizationName">
                                                        <Form.Label>Company Name</Form.Label>
                                                        <InputGroup hasValidation>
                                                            <Form.Control
                                                                type="text"
                                                                name="organizationName"
                                                                value={values.organizationName}
                                                                onChange={handleChange}
                                                                isInvalid={touched.organizationName && !!errors.organizationName}
                                                            />
                                                            {touched.organizationName && (<Form.Control.Feedback type="invalid">
                                                                {errors.organizationName}
                                                            </Form.Control.Feedback>)}
                                                        </InputGroup>
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} md="4" controlId="email">
                                                        <Form.Label>Email</Form.Label>
                                                        <InputGroup hasValidation>
                                                            <Form.Control
                                                                type="text"
                                                                name="email"
                                                                value={values.email}
                                                                onChange={handleChange}
                                                                isInvalid={touched.email && !!errors.email}
                                                            />
                                                            {touched.email && (<Form.Control.Feedback type="invalid">
                                                                {errors.email}
                                                            </Form.Control.Feedback>)}
                                                        </InputGroup>
                                                    </Form.Group>
                                                    <Form.Group as={Col} md="4" controlId="password">
                                                        <Form.Label>Password</Form.Label>
                                                        <InputGroup hasValidation>
                                                            <Form.Control
                                                                type="password"
                                                                name="password"
                                                                value={values.password}
                                                                onChange={handleChange}
                                                                isInvalid={touched.password && !!errors.password}
                                                            />
                                                            {touched.password && (<Form.Control.Feedback type="invalid">
                                                                {errors.password}
                                                            </Form.Control.Feedback>)}
                                                        </InputGroup>
                                                    </Form.Group>
                                                    <Form.Group as={Col} md="4" controlId="passwordConfirm">
                                                        <Form.Label>Confirm Password</Form.Label>
                                                        <InputGroup hasValidation>
                                                            <Form.Control
                                                                type="password"
                                                                name="passwordConfirm"
                                                                value={values.passwordConfirm}
                                                                onChange={handleChange}
                                                                isInvalid={touched.passwordConfirm && !!errors.passwordConfirm}
                                                            />
                                                            {touched.passwordConfirm && (<Form.Control.Feedback type="invalid">
                                                                {errors.passwordConfirm}
                                                            </Form.Control.Feedback>)}
                                                        </InputGroup>
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} md="8" controlId="address">
                                                        <Form.Label>Address</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="address"
                                                            value={values.address}
                                                            onChange={handleChange}
                                                            isInvalid={touched.address && !!errors.address}
                                                        />

                                                        {touched.address && (<Form.Control.Feedback type="invalid">
                                                            {errors.address}
                                                        </Form.Control.Feedback>)}
                                                    </Form.Group>
                                                    <Form.Group as={Col} md="4" controlId="phoneNumber">
                                                        <Form.Label>Phone Number</Form.Label>
                                                        <InputGroup hasValidation>
                                                            <Form.Control
                                                                type="text"
                                                                name="phoneNumber"
                                                                value={values.phoneNumber}
                                                                onChange={handleChange}
                                                                isInvalid={touched.phoneNumber && !!errors.phoneNumber}
                                                            />
                                                            {touched.phoneNumber && (<Form.Control.Feedback type="invalid">
                                                                {errors.phoneNumber}
                                                            </Form.Control.Feedback>)}
                                                        </InputGroup>
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} md="4" controlId="city">
                                                        <Form.Label>City</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="city"
                                                            value={values.city}
                                                            onChange={handleChange}
                                                            isInvalid={touched.city && !!errors.city}
                                                        />

                                                        {touched.city && (<Form.Control.Feedback type="invalid">
                                                            {errors.city}
                                                        </Form.Control.Feedback>)}
                                                    </Form.Group>
                                                    <Form.Group as={Col} md="4" controlId="prov">
                                                        <Form.Label>Prov / State</Form.Label>
                                                        <Form.Select
                                                            aria-label="prov"
                                                            name={"prov"}
                                                            value={values.prov}
                                                            onChange={handleChange}
                                                            isInvalid={touched.prov && !!errors.prov}
                                                        >
                                                            {provList[values.country].map(p => (
                                                                <option key={p.code} value={p.code}>{p.name}</option>
                                                            ))}
                                                        </Form.Select>
                                                        {touched.prov && (<Form.Control.Feedback type="invalid">
                                                            {errors.prov}
                                                        </Form.Control.Feedback>)}
                                                    </Form.Group>
                                                    <Form.Group as={Col} md="4" controlId="postCode">
                                                        <Form.Label>Postal Code / Zip</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="postCode"
                                                            value={values.zip}
                                                            onChange={handleChange}
                                                            isInvalid={touched.postCode && !!errors.postCode}
                                                        />

                                                        {touched.postCode && (<Form.Control.Feedback type="invalid">
                                                            {errors.postCode}
                                                        </Form.Control.Feedback>)}
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} md="4" controlId="country">
                                                        <Form.Label>Country</Form.Label>
                                                        <Form.Select
                                                            aria-label="country"
                                                            name={"country"}
                                                            value={values.country}
                                                            onChange={handleChange}
                                                            isInvalid={touched.country && !!errors.country}
                                                        >
                                                            <option value={"CA"}>Canada</option>
                                                            <option value={"US"}>United States</option>
                                                        </Form.Select>

                                                        {touched.country && (<Form.Control.Feedback type="invalid">
                                                            {errors.country}
                                                        </Form.Control.Feedback>)}
                                                    </Form.Group>
                                                </Row>
                                                <Form.Group className="mb-3">
                                                    <Form.Check
                                                        required
                                                        name="terms"
                                                        label="Agree to terms and conditions"
                                                        onChange={handleChange}
                                                        isInvalid={touched.terms && !!errors.terms}
                                                        feedback={errors.terms}
                                                        feedbackType="invalid"
                                                        id="validationFormik0"
                                                    />
                                                </Form.Group>
                                                <Button type="submit" disabled={isSubmitting}>Submit Registration</Button>
                                            </Form>
                                        )}
                                    </Formik>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

        );
    }

}


export default RegisterResellerPage;
